import React from 'react'
import Img from 'gatsby-image'
import { getFluidGatsbyImage } from 'gatsby-source-sanity'
import clientConfig from '../../client-config'

export default ({ node }) => {
  if (!node || !node.asset || !node.asset._id) { return null }
  const fluidProps = getFluidGatsbyImage(
    node.asset._id,
    { maxWidth: 675 },
    clientConfig.sanity
  )

  const imgStyle = {
    borderRadius: '0.5rem',
    boxShadow: '0 0 0.6rem rgba(0, 0, 0, 0.1)',
  }
  const imgComponent = (node.asset.extension === 'svg'
    // Avoid gatsby-image for SVG assets which look best in their native format
    ? <img src={node.asset.url} alt={node.alt} style={imgStyle} />
    : <Img fluid={fluidProps} alt={node.alt} style={imgStyle} />)

  return (
    <figure style={{
      textAlign: 'center',
      marginTop: '4rem',
    }}>
      <figcaption style={{
        marginBottom: '1rem',
      }}>{node.caption}</figcaption>
      {imgComponent}
    </figure>
  )
}
